// extracted by mini-css-extract-plugin
export default {"buttonFaqColors":"faqColor_buttonFaqColors__XfA2K","colorContainer":"faqColor_colorContainer__yB5-w"};